<template>
    <div class="page">
        <v-container class="py-3 py-lg-6">
            <v-card v-if="pageData" :class="{'py-2 px-3 bordered': pcOnly}" flat>
                <v-card-title :class="{'px-2': phoneOnly}">سياسة الخصوصية</v-card-title>
                <v-card-text :class="{'px-2': phoneOnly}">
                    <p class="strong-text--text medium-text" style="white-space: pre-line; line-height: 2">
                        {{pageData.text}}
                    </p>
                </v-card-text>
            </v-card>
        </v-container>

        <slot v-if="!isAuthed" name="footer" />
    </div>
</template>
<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    components: {
        
    },
    data(){
        return {
            loading: false,
            pageData: null,
        }
    },
    computed: {
        ...GlobalComputed,
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        ...GlobalMethods,

        getPageData(){
            if (!this.loading){
                this.loading = true;
                const url = '/privacy';
                this.$store.dispatch('fastGetAction', {url}).then(response=>{
                    this.loading = false;
                    this.pageData = response.data;

                }).catch(()=>{
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    mounted(){
        if (!this.pageData){
            this.getPageData();
        }
    }
}
</script>